/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_FailedInputs */

const cs_gallery_failed = /** @type {(inputs: Gallery_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrání fotky se nezdařilo`)
};

const en_gallery_failed = /** @type {(inputs: Gallery_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo upload failed`)
};

/**
* | output |
* | --- |
* | "Photo upload failed" |
*
* @param {Gallery_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_failed = /** @type {((inputs?: Gallery_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_failed(inputs)
	return cs_gallery_failed(inputs)
});